import React, { useRef, useEffect, useCallback, useState } from 'react';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';
import { useField } from '@unform/core';

import ReactInputMask, { Props as InputProps } from 'react-input-mask';
import { Container, Error } from './styles';

interface Props extends InputProps {
  name: string;
  mask: string;
  containerStyle?: React.CSSProperties;
  icon?: React.ComponentType<IconBaseProps>;
  large?: boolean;
  label?: string;
  disabled?: boolean;
}

const InputMask: React.FC<Props> = ({
  name,
  mask,
  containerStyle = {},
  large = false,
  icon: Icon,
  label = '',
  disabled = false,
  ...rest
}) => {
  const inputRef = useRef<ReactInputMask>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);

    // setIsFilled(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue(ref, value) {
        ref.setInputValue(value);
      },
      clearValue(ref) {
        ref.setInputValue('');
      },
    });
  }, [inputRef, fieldName, registerField]);

  return (
    <>
      {label && (
        <b style={{ marginBottom: '4px', display: 'block' }}>{label}</b>
      )}
      <Container
        style={containerStyle}
        isErrored={!!error}
        isFocused={isFocused}
        isFilled={isFilled}
        large={large}
        disabled={disabled}
        type={rest.type}
      >
        <ReactInputMask
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          ref={inputRef}
          mask={mask}
          defaultValue={defaultValue}
          // onChange={e => handleMask(e)}
          disabled={disabled}
          {...rest}
        />
        {error && (
          <Error title={error}>
            <FiAlertCircle color="#c53030" size={20} />{' '}
          </Error>
        )}
      </Container>
    </>
  );
};

export default InputMask;
